// src/utils/ComponentUtil.ts

export interface Attr {
    trName: string,
    trTitle: string,
    trValue: string,
}

class ComponentUtil {

    public showTable(colSpan:number, target: any, ele: any, attrList: Attr[]) {
        let td = target.parentNode
        let tr = td.parentNode
        if (ele.isOpen) {
            ele.isOpen = false
            target.classList.remove('fa-caret-up')
            target.classList.add('fa-caret-down')
            // remove element
            for (let i = 0; i < attrList.length; i++) {
                const attr = attrList[i]
                if (ele[attr.trName]) {
                    let attrElement = ele[attr.trName]
                    attrElement.remove()
                    delete ele[attr.trName]
                }
            }
        }
        else {
            ele.isOpen = true
            target.classList.remove('fa-caret-down')
            target.classList.add('fa-caret-up')

            for (let i = 0; i < attrList.length; i++) {
                const attr = attrList[i]
                let attrElement = document.createElement('tr')
                attrElement.innerHTML = `<td colSpan="${colSpan}" style="word-wrap: break-word"><strong>${attr.trTitle}</strong>: ${attr.trValue}</td>`
                if (tr.parentNode && tr.nextSibling) tr.parentNode.insertBefore(attrElement, tr.nextSibling)
                else tr.parentNode.append(attrElement)
                ele[attr.trName] = attrElement
            }
        }
    }

    public showDetail(colSpan:number, index: number, target: any, tableList: any[], attrList: Attr[]) {
        let td = target.parentNode
        let tr = td.parentNode
        let user = tableList[index]
        if (user.isOpen) {
            user.isOpen = false
            target.classList.remove('fa-caret-up')
            target.classList.add('fa-caret-down')
            // remove element
            for (let i = 0; i < attrList.length; i++) {
                const attr = attrList[i]
                if (user[attr.trName]) {
                    let attrElement = user[attr.trName]
                    attrElement.remove()
                    delete user[attr.trName]
                }
            }
        }
        else {
            user.isOpen = true
            target.classList.remove('fa-caret-down')
            target.classList.add('fa-caret-up')

            for (let i = 0; i < attrList.length; i++) {
                const attr = attrList[i]
                let attrElement = document.createElement('tr')
                attrElement.innerHTML = `<td colSpan="${colSpan}"><strong>${attr.trTitle}</strong>: ${attr.trValue}</td>`
                if (tr.parentNode && tr.nextSibling) tr.parentNode.insertBefore(attrElement, tr.nextSibling)
                else tr.parentNode.append(attrElement)
                user[attr.trName] = attrElement
            }
        }
    }
}

export let componentUtil = new ComponentUtil()